import { PdpReviewForm } from 'features/review-form/review-form-connected';
import React from 'react';
import { Redirect } from '@okapi/router-react';
import { Breakpoint } from 'types/utils';
import {
  LARGE_DESK_SCREEN,
  MEDIUM_DESK_SCREEN,
  TABLET_SCREEN,
  MOBILE_SCREEN,
} from 'utils/internal-specifics/media-queries';
import { addMediaQueryHandlers } from 'utils/add-media-query-handlers';
import { useSelector } from 'react-redux';
import { getIsReviewFormRemoteEnabled } from 'common/selectors';

export const ReviewsFormContent: React.FC = () => {
  const isReviewFormRemoteEnabled = useSelector(getIsReviewFormRemoteEnabled);

  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>('large');

  React.useEffect(
    () =>
      addMediaQueryHandlers(
        [LARGE_DESK_SCREEN, MEDIUM_DESK_SCREEN, TABLET_SCREEN, MOBILE_SCREEN],
        ['large', 'medium', 'tablet', 'mobile'],
        'large',
        setBreakpoint,
      ),
    [],
  );

  return (
    <>{isReviewFormRemoteEnabled ? <Redirect to="/404" /> : <PdpReviewForm breakpoint={breakpoint} />}</>
  );
};
